import * as Yup from 'yup';

export function formValidation() {
  return Yup.object().shape({
    Name: Yup.string()
      .min(2, 'Should be at least 2 characters long')
      .max(50, 'Should be less than 50 characters long')
      .required('Required'),
    Type: Yup.string()
      .required('Required')
  });
}